import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as componentTypes from "../../../../constants/componentTypes";
import * as config from "../../../../constants/config";
import * as mainTabActions from "../../../../actions/mainTabActions";
import * as navigationActions from "../../../../actions/navigationActions";
import * as modelHelper from "../../../../helpers/modelHelper";

import Button from "../../../global/generic/Button";
import CancelButton from "../../../global/generic/CancelButton";
import Modal from "../../../global/generic/Modal";
import Table, {TABLE_VARIANT_SECONDARY} from "../../../global/generic/Table";

import imgConfirm from "../../../../resources/img/svgicons/confirm.svg";
import imgLoader from "../../../../resources/img/loader.svg";

class BuildingSiteListModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            buildingSite: props.buildingSite,
            offset: config.MAX_ORDERS_LIMIT
        };
    }

    componentDidMount() {
        if (this.props.customer !== null) {
            this.props.dispatchGetBuildingSitesAction(this.props.tabId, this.props.customer.id);
        }
    }

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleSetBuildingSiteClick = () => {
        if (this.state.buildingSite !== null) {
            this.props.dispatchSetBuildingSiteAction(this.props.tabId, this.state.buildingSite);
            this.props.dispatchCloseModalAction();
        }
    };

    handleBuildingSiteScroll = (event) => {
        if (
            this.props.customer !== null &&
            event.target.scrollHeight <= Math.ceil(event.target.scrollTop + event.target.clientHeight + 15) &&
            this.state.offset <= this.props.buildingSiteList.length
        ) {
            this.props.dispatchGetBuildingSitesWithOffsetAction(
                this.props.tabId,
                this.props.customer.id,
                this.state.offset
            );
            this.setState({
                offset: this.state.offset + config.MAX_ORDERS_LIMIT
            });
        }
    };

    handleTableItemClick = (event) => {
        if (event.currentTarget.dataset.name) {
            this.setState({buildingSite: event.currentTarget.dataset.name.trim()});
        }
    };

    getTableHeader = () => {
        return modelHelper.buildTableRow([modelHelper.buildTableCell(<Translate value="general.buildingSite" />)]);
    };

    getTableRows = () => {
        return this.props.buildingSiteList.map((buildingSite) => {
            return modelHelper.buildTableRow(
                [modelHelper.buildTableCell(buildingSite, "font-size-1_75em")],
                this.state.buildingSite === buildingSite ? "padding-15 active" : "padding-15",
                buildingSite,
                {"data-name": buildingSite, onClick: this.handleTableItemClick}
            );
        });
    };

    getTableColumns = () => {
        return [modelHelper.buildTableColumn("col-12")];
    };

    getContent = () => {
        if (this.props.loading) {
            return modelHelper.buildModalSection(
                <div className="col-12 flex flex-align-center-horizontal">
                    <img alt="loader" src={imgLoader} />
                </div>
            );
        }

        if (!Array.isArray(this.props.buildingSiteList) || this.props.buildingSiteList.length === 0) {
            return modelHelper.buildModalSection(
                <div className="col-12 flex flex-align-center-horizontal">
                    <Translate value="mainTab.noResultsFound" />
                </div>
            );
        }

        return modelHelper.buildModalSection(
            <Table
                variant={TABLE_VARIANT_SECONDARY}
                className="flex-child"
                tableHeader={this.getTableHeader()}
                tableRows={this.getTableRows()}
                tableColumns={this.getTableColumns()}
                onScroll={this.handleBuildingSiteScroll}
            />
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="flex text-elipsis">
                    <Button
                        className="margin-right-5"
                        label={<Translate value="general.ok" />}
                        svgBefore={imgConfirm}
                        disabled={this.state.buildingSite === null}
                        onClick={this.handleSetBuildingSiteClick}
                    />
                    <CancelButton onClick={this.handleCloseModalClick} />
                </div>
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="mainTab.addBuildingSite" />)}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{minWidth: "60%"}}
            />
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    if (ownProps.tabId === undefined || store.formula[ownProps.tabId] === undefined) {
        return {
            customer: null,
            buildingSite: null,
            buildingSiteList: null,
            loading: false
        };
    }

    return {
        customer: store.formula[ownProps.tabId].customer,
        buildingSite: store.formula[ownProps.tabId].buildingSite,
        buildingSiteList: store.formula[ownProps.tabId].buildingSiteList,
        loading: store.server.requests.some((request) => request.tabId === ownProps.tabId)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchGetBuildingSitesAction: (tabId, customerId) => {
            dispatch(mainTabActions.getBuildingSites(tabId, customerId));
        },
        dispatchGetBuildingSitesWithOffsetAction: (tabId, customerId, offset) => {
            dispatch(mainTabActions.getBuildingSitesWithOffset(tabId, customerId, offset));
        },
        dispatchSetBuildingSiteAction: (tabId, buildingSite) => {
            dispatch(mainTabActions.setBuildingSite(tabId, buildingSite));
        },
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.BUILDING_SITE_LIST_MODAL));
        }
    };
};

export default BuildingSiteListModal = connect(mapStoreToProps, mapDispatchToProps)(BuildingSiteListModal);
